import { jsx, jsxs } from "react/jsx-runtime";
import { isCallState, isOutputState } from "./types.js";
function AnalyzeQueryPart({ part }) {
  if (isCallState(part.state)) {
    return /* @__PURE__ */ jsx("div", { className: "concierge-search-loading", children: /* @__PURE__ */ jsx("div", { className: "concierge-search-loading-text", children: "Analyzing your query..." }) });
  }
  if (isOutputState(part.state) && part.output) {
    const { intent, brands, features, searchAngles, numAngles } = part.output;
    return /* @__PURE__ */ jsx("div", { className: "concierge-search-results", children: /* @__PURE__ */ jsxs("div", { className: "concierge-search-summary", children: [
      intent && /* @__PURE__ */ jsxs("span", { children: [
        "Intent: ",
        intent
      ] }),
      (brands == null ? void 0 : brands.length) > 0 && /* @__PURE__ */ jsxs("span", { children: [
        " · Brands: ",
        brands.join(", ")
      ] }),
      (features == null ? void 0 : features.length) > 0 && /* @__PURE__ */ jsxs("span", { children: [
        " · Features: ",
        features.join(", ")
      ] }),
      numAngles > 0 && /* @__PURE__ */ jsxs("span", { children: [
        " · ",
        numAngles,
        " search angle",
        numAngles !== 1 ? "s" : "",
        " planned"
      ] })
    ] }) });
  }
  return null;
}
export {
  AnalyzeQueryPart
};
//# sourceMappingURL=AnalyzeQueryPart.js.map
